import { androidDispatchers, autoWebViewJs, openHtmlShowA11yNodeInfoButton } from "@droid/android";
import { IA11yNodeInfo } from "@droid/project-interface";
import { toProxy, useProxyWatch, useTranslation } from "@fanfanlo";
import { Button } from "@mui/material";
import { ulid } from "ulid";

const data = toProxy({opened:false})
async function onClick() {

    if(data.opened)return;
    const eventType = "a11yNodeSelectActionItem"
    const selectEventIndex = autoWebViewJs.shellListen(androidDispatchers.WebViewJsDispatcher.name, eventType, eventType, false, onSelectNode)
    function onSelectNode(s: string) {
        clear()
        autoWebViewJs.clipboardSetText(s)
        // const info: IA11yNodeInfo = JSON.parse(s)
        // console.log('fffffffffffffff', s)
    }
    function clear(){
        data.opened = false;
        console.log('ccccccccccclear')
        autoWebViewJs.shellRemoveListen(androidDispatchers.WebViewJsDispatcher.name, selectEventIndex);
        autoWebViewJs.shellRemoveListen(androidDispatchers.Window.name, exitWindowIndex);
        if(exitWebviewJsIndex){
            autoWebViewJs.removeListen(androidDispatchers.Window.name, parseInt(exitWebviewJsIndex));
        }
    }
    const windowId = ulid()
    openHtmlShowA11yNodeInfoButton(eventType, windowId)
    data.opened = true;
    const et = `window-${windowId}-dismiss`
    const {javaResultString:exitWebviewJsIndex, errMsg} = autoWebViewJs.listen(androidDispatchers.Window.name, et, et, true)
    if(errMsg){
        throw new Error(errMsg)
    }
    const exitWindowIndex = autoWebViewJs.shellListen(androidDispatchers.Window.name, et, et, true, ()=>{
        clear()
    });
}
export function OpenA11yNodeButton() {
    const { t } = useTranslation('homepage/components/a11y/content')
    const [opened] = useProxyWatch(data, 'opened', data.opened)
    return <>
        <Button onClick={onClick} disabled={opened}>{t("open-a11y-node-button.btnName")}</Button>
    </>
}